import React from "react";
import { Link } from "gatsby";
import PropTypes from "prop-types";
import MediaQuery from "react-responsive";
import { navBar, burger, flex_nav_btn } from "./header.module.scss";
import Logo from "./components/logo";
import DesktopHeader from "./components/DesktopHeader";
import BurgerMenu from "./components/BurgerMenu";

const Header = () => {
  return (
    <>
      <MediaQuery maxWidth={900}>
        <header>
          <div className={navBar}>
            <div>
              <Link to="/">
                <Logo />
              </Link>
            </div>
            <div className={flex_nav_btn}>
              <button>
                <Link style={{ color: "white" }} to="/reserva-collar-kolyy">
                  <b>Reserva tu collar</b>
                </Link>
              </button>
              <div className={burger}>
                <BurgerMenu />
              </div>
            </div>
          </div>
        </header>
      </MediaQuery>
      <MediaQuery minWidth={901}>
        <DesktopHeader />
      </MediaQuery>
    </>
  );
};

Header.propTypes = {
  siteTitle: PropTypes.string,
};

export default Header;
